// extracted by mini-css-extract-plugin
export default {"customCell":"styles_customCell__IvNjK","table":"styles_table__lYILL"};